import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border-grey-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " Tidak ada data ditemukan. ", -1)

import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import ProgressSpinner from 'primevue/progressspinner'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import currencyNumberFormat from '@/utils/helpers/rupiahFormat'
import { useRoute } from 'vue-router'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import apiUseCase from '@/usecase/apiUseCase'
import Paginator from '@/views/components/paginator/Paginator.vue'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailTable',
  setup(__props) {

const transactionPpsEndpoint = 'transaction/v2/TransactionPps'
const route = useRoute()
const store = useStore()
const selectedStatId = ref(null) as any
const transactionPpId = ref(encryptDecriptMethods.decrypt(route.params.id))
const transactionTicketList = ref([]) as any
const dataSource = ref([]) as any
const idPrams = ref()

const filters = ref({
  search: '',
  filterField: ['trayekName'],
  pageNumber: 1,
  pageSize: 10,
  totalRecords: 0,
  custom: [] as any
})

const getDataDetail = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${transactionPpsEndpoint}/NonCash/Completed/${idPrams.value?.headerId}/TransactionPps/${idPrams.value?.Id}/Tickets`, returnUrlPrams(filters.value)).then((response) => {
    const { error, result, count } = response
    if (!error) {
      filters.value.totalRecords = count
      dataSource.value = result
    }
  })
  store.dispatch('hideLoading')
}

const onChangePage = ({ page, rows }: any) => {
  filters.value.pageNumber = page + 1
  filters.value.pageSize = rows
  // eslint-disable-next-line no-use-before-define
  getDataDetail()
}

onMounted(() => {
  idPrams.value = encryptDecriptMethods.decrypt(route.params.id)
  getDataDetail()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(DataTable), {
        value: _unref(dataSource),
        rows: 5,
        class: "closing-stat-detail w-full"
      }, {
        empty: _withCtx(() => [
          _hoisted_2
        ]),
        loading: _withCtx(() => [
          _createVNode(_unref(ProgressSpinner), { style: {"width":"70px","height":"70px"} })
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Column), {
            header: "NO. KARCIS",
            style: {"width":"250px"}
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(data.Code ?? '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            header: "ASAL - TUJUAN",
            style: {"width":"150px"}
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(`${data.OriginTerminalCode} - ${data.DestinationTerminalCode}`), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            header: "RIT",
            style: {"width":"80px"}
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(data.RitOrder ?? '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            header: "NON-TUNAI",
            style: {"width":"200px"}
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(data.PaymentType.toLowerCase() === 'nontunai' ? _unref(currencyNumberFormat)(data.Price) : '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            header: "ONLINE",
            style: {"width":"200px"}
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(data.PaymentType.toLowerCase() === 'online' ? _unref(currencyNumberFormat)(data.Price) : '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            header: "TUNAI",
            style: {"width":"200px"}
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(data.PaymentType.toLowerCase() === 'tunai' ? _unref(currencyNumberFormat)(data.Price) : '-'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"]),
      _createVNode(Paginator, {
        rows: filters.value.pageSize,
        totalRecords: filters.value.totalRecords,
        rowsPerPageOptions: [5, 10, 15, 20, 25],
        onOnPage: onChangePage
      }, null, 8, ["rows", "totalRecords"])
    ])
  ]))
}
}

})